import { useEffect, useState } from "react";
import "./index.sass";

interface NumberProps {
  initNumber: number;
  finalNumber: number;
  duration?: number; // Duración en milisegundos
  startAnimation: boolean; // Inicia la animación
  resetAnimation?: boolean; // Reinicia el número antes de animar
  decimal?: number; // Cantidad de decimales a mostrar
  style?: React.CSSProperties;
}

const Number = ({
  initNumber,
  finalNumber,
  duration = 1000,
  startAnimation,
  resetAnimation = false,
  decimal = 0,
  style = {},
}: NumberProps) => {
  const [currentNumber, setCurrentNumber] = useState(initNumber);

  useEffect(() => {
    if (resetAnimation) {
      setCurrentNumber(initNumber);
    }
  }, [resetAnimation, initNumber]);

  useEffect(() => {
    if (!startAnimation) return;

    setCurrentNumber(initNumber); // Reinicia en caso de ser necesario
    if (initNumber === finalNumber) return;

    const stepTime = 16; // ~60 FPS (cada 16ms un frame)
    const totalSteps = Math.floor(duration / stepTime);
    const stepSize = (finalNumber - initNumber) / totalSteps;

    let stepCount = 0;
    const interval = setInterval(() => {
      stepCount++;
      setCurrentNumber((prev) => {
        const nextNumber = prev + stepSize;
        return stepCount >= totalSteps ? finalNumber : nextNumber;
      });

      if (stepCount >= totalSteps) {
        clearInterval(interval);
      }
    }, stepTime);

    return () => clearInterval(interval);
  }, [startAnimation, initNumber, finalNumber, duration]);

  return (
    <div className="numbers-effect" style={style}>
      {parseFloat(currentNumber.toFixed(decimal))}
    </div>
  );
};

export default Number;
